import {
    UDPATE_FROM_HASH,
    SHOW_EULA,
    EULA_INITIATED,
    EULA_PROMPTED,
    EULA_NOT_OK,
    EULA_DECLINED,
    EULA_ACCEPTED,
} from './constants'

export function updateEulaFromHashIfOutdated(hash) {
    return {
        type: UDPATE_FROM_HASH,
        payload: hash,
    }
}

export function showEulaPrompt(userId, hash, accepted) {
    return { type: SHOW_EULA, payload: { userId, hash, accepted } }
}

export function eulaInitated(userId) {
    return { type: EULA_INITIATED, payload: userId }
}

export function eulaPrompted(userId) {
    return { type: EULA_PROMPTED, payload: userId }
}

export function eulaNotOk(userId) {
    return { type: EULA_NOT_OK, payload: userId }
}

export function eulaDeclined(userId) {
    return { type: EULA_DECLINED, payload: userId }
}

export function eulaAccepted(userId) {
    return { type: EULA_ACCEPTED, payload: userId }
}



// WEBPACK FOOTER //
// ./src/features/Eula/data/actions.js